import { render, staticRenderFns } from "./SPRSimpleNumberCheckbox.vue?vue&type=template&id=be8f7798&scoped=true"
import script from "./SPRSimpleNumberCheckbox.vue?vue&type=script&lang=ts"
export * from "./SPRSimpleNumberCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./SPRSimpleNumberCheckbox.vue?vue&type=style&index=0&id=be8f7798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8f7798",
  null
  
)

export default component.exports